/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Comunicados de imprensa - CamAPS FX',
    titleMeta: 'Comunicados de imprensa - CamAPS FX',
    descriptionMeta: 'Mantenha-se a par dos nossos anúncios mais recentes.',
    keywords: 'comunicados de imprensa camaps, notícias camaps, tecnologia diabetes',
    localeMeta: 'pt_PT',

    bannerTitle: 'Comunicados de imprensa',
    bannerSubtitle: 'Mantenha-se a par dos nossos anúncios mais recentes.',

    contactText: 'Para quaisquer questões da imprensa, contacte via <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Todos os comunicados de imprensa são publicados em inglês.',

    download: 'Descarregar',
    showMore: 'Mostrar mais',
    showLess: 'Mostrar menos',
};
